import OrderFinishedCargoOrdersCountRequest, {
  OrderFinishedCargoOrdersCountRequestOrder,
  OrderFinishedCargoOrdersCountRequestPublicStatus,
} from "../../../../api/raily/order/finished-cargo-orders/count/order-finished-cargo-orders-count.request";
import PublicStatus from "../../../../types/public-status";
import OrderFinishedCargoOrdersCountParams, {
  OrderFinishedCargoOrdersCountParamsOrder,
} from "./order-finished-cargo-orders-count-params";

const createOrder = (
  order: OrderFinishedCargoOrdersCountParamsOrder | undefined,
): OrderFinishedCargoOrdersCountRequestOrder | undefined => {
  switch (order) {
    case OrderFinishedCargoOrdersCountParamsOrder.CREATED_AT_ASC:
      return OrderFinishedCargoOrdersCountRequestOrder.CREATED_AT_ASC;
    case OrderFinishedCargoOrdersCountParamsOrder.CREATED_AT_DESC:
      return OrderFinishedCargoOrdersCountRequestOrder.CREATED_AT_DESC;
    case OrderFinishedCargoOrdersCountParamsOrder.HUMAN_ID_ASC:
      return OrderFinishedCargoOrdersCountRequestOrder.HUMAN_ID_ASC;
    case OrderFinishedCargoOrdersCountParamsOrder.HUMAN_ID_DESC:
      return OrderFinishedCargoOrdersCountRequestOrder.HUMAN_ID_DESC;
    case OrderFinishedCargoOrdersCountParamsOrder.MODIFIED_AT_ASC:
      return OrderFinishedCargoOrdersCountRequestOrder.MODIFIED_AT_ASC;
    case OrderFinishedCargoOrdersCountParamsOrder.MODIFIED_AT_DESC:
      return OrderFinishedCargoOrdersCountRequestOrder.MODIFIED_AT_DESC;
    case OrderFinishedCargoOrdersCountParamsOrder.START_TIME_ASC:
      return OrderFinishedCargoOrdersCountRequestOrder.START_TIME_ASC;
    case OrderFinishedCargoOrdersCountParamsOrder.START_TIME_DESC:
      return OrderFinishedCargoOrdersCountRequestOrder.START_TIME_DESC;
    default:
      return undefined;
  }
};

const createPublicStatus = (
  status: PublicStatus | undefined,
): OrderFinishedCargoOrdersCountRequestPublicStatus | undefined => {
  switch (status) {
    case PublicStatus.PRIVATE:
      return OrderFinishedCargoOrdersCountRequestPublicStatus.PRIVATE;
    case PublicStatus.PUBLIC:
      return OrderFinishedCargoOrdersCountRequestPublicStatus.PUBLIC;
    case PublicStatus.PUBLISHED:
      return OrderFinishedCargoOrdersCountRequestPublicStatus.PUBLISHED;
    default:
      return undefined;
  }
};

const create = (
  params: OrderFinishedCargoOrdersCountParams,
): OrderFinishedCargoOrdersCountRequest => {
  return {
    address: params.address,
    client: params.client,
    dispatch: params.dispatch,
    driver: params.driver,
    endAddress: params.endAddress,
    externalId: params.externalId,
    humanId: params.humanId,
    isApproved: params.isApproved,
    isCancelled: params.isCancelled,
    midAddress: params.midAddress,
    order: createOrder(params.order),
    passenger: params.passenger,
    publicStatus: createPublicStatus(params.publicStatus),
    startAddress: params.startAddress,
    startTimeSince: params.startTimeSince,
    startTimeTo: params.startTimeTo,
    taxi: params.taxi,
  };
};

const orderFinishedCargoOrdersCountParamsFactory = {
  create,
};

export default orderFinishedCargoOrdersCountParamsFactory;
